module.exports = __webpack_public_path__ + "static/media/mob-basketball.4e575436.webp";